// src/features/files/upload/useFilePicker.jsx
import React, { useCallback, useRef } from 'react';

/**
 * Opens the system file picker from any button: render `input` once, call
 * `open()` on click. The input is reset after each pick, so choosing the same
 * file again still triggers `onFiles`.
 */
export function useFilePicker({ onFiles, accept, multiple = true }) {
  const inputRef = useRef(null);

  const open = useCallback(() => inputRef.current?.click(), []);

  const input = (
    <input
      ref={inputRef}
      type="file"
      hidden
      accept={accept}
      multiple={multiple}
      onChange={(event) => {
        const files = Array.from(event.target.files || []);
        event.target.value = '';
        if (files.length) onFiles(files);
      }}
    />
  );

  return { open, input };
}
